import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Box, Typography, Container } from '@mui/material';
import HerramientasView from '../components/herramientas/HerramientasView';

export const Herramientas: React.FC = () => {
    return (
        <Layout>
            <Container maxWidth="xl" sx={{ height: 'calc(100vh - 80px)', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    mt: 2,
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2
                }}>
                    <Box>
                        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                            Control de Herramientas
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Gestión estilo Kanban para herramientas propias y alquiladas
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
                    <HerramientasView />
                </Box>
            </Container>
        </Layout>
    );
};
